import { debounce } from "lodash-es";

// Счетчик для отслеживания вызовов функций hideScroll и showScroll
let counter = 0;

// Класс вешаем и на <html>, и на <body>: настоящий скролл-контейнер — это
// documentElement (у html/body height:100%), а WebKit не пробрасывает overflow
// с body на viewport, и без блокировки самого html прокрутка глушится не до конца.
const update = debounce(function () {
    const enabled = counter > 0;
    document.documentElement.classList.toggle("no-scroll", enabled);
    document.body.classList.toggle("no-scroll", enabled);
}, 30);

// Экспортируемый объект с методами hideScroll и showScroll
export default {
    /**
     * Увеличивает счетчик и запускает функцию обновления.
     */
    hideScroll() {
        counter++;
        update();
    },
    /**
     * Уменьшает счетчик и запускает функцию обновления.
     */
    showScroll() {
        counter--;
        update();
    }
};
